module.exports = __webpack_public_path__ + "static/media/logo_harinerachiapas.014d6d44.jpg";